import React, { useState } from "react";
import { useTeamLocale } from "./TeamLocaleContext";
import ManualBookingForm from "./ManualBookingForm";
import BookingsTab from "./BookingsTab";

const ManualBookingTab = () => {
  const { t } = useTeamLocale();
  const [reloadSignal, setReloadSignal] = useState(0);

  return (
    <div className="team-manual">
      <ManualBookingForm onCreated={() => setReloadSignal((n) => n + 1)} />

      <div className="team-manual-list">
        <h2 className="team-manual-list-title">{t("manual.listTitle")}</h2>
        <BookingsTab
          manualOnly
          reloadSignal={reloadSignal}
          leadKey="manual.listLead"
        />
      </div>
    </div>
  );
};

export default ManualBookingTab;
